import { PublicApiVendorEnum } from 'api/enums';
import { immerable } from 'immer';

/* -------------------------------------------------------------------------------------------------
 * IPublicApiIngestionModel
 * -----------------------------------------------------------------------------------------------*/

export interface IPublicApiIngestionModel {
    _id: string;
    title: string;
    apiKey: string;
    apiSecret: string;
    access: string[];
    generatedOn: string;
    cameras: string[];
    vendor: PublicApiVendorEnum;
    user: string;
    client: string;
}

/* -------------------------------------------------------------------------------------------------
 * PublicApiIngestionModel
 * -----------------------------------------------------------------------------------------------*/

export class PublicApiIngestionModel {
    [immerable] = true;

    _id: string;
    title: string;
    apiKey: string;
    apiSecret: string;
    access: string[];
    generatedOn: string;
    cameras: string[];
    vendor: PublicApiVendorEnum;
    user: string;
    client: string;

    constructor(data: Partial<IPublicApiIngestionModel>) {
        this._id = data._id || '';
        this.title = data.title ?? '';
        this.apiKey = data.apiKey ?? '';
        this.apiSecret = data.apiSecret ?? '';
        this.access = data.access ?? [];
        this.generatedOn = data.generatedOn ?? '';
        this.cameras = data.cameras ?? [];
        this.vendor = data.vendor;
        this.user = data.user ?? '';
        this.client = data.client ?? '';
    }

    static fromObject(data: Partial<IPublicApiIngestionModel>): PublicApiIngestionModel {
        const model = new PublicApiIngestionModel(data);

        return model;
    }

    static cloneFrom(data: Partial<IPublicApiIngestionModel>): PublicApiIngestionModel {
        const model = new PublicApiIngestionModel(data);

        return model;
    }

    toObject(): IPublicApiIngestionModel {
        const data: IPublicApiIngestionModel = {
            _id: this._id,
            title: this.title,
            apiKey: this.apiKey,
            apiSecret: this.apiSecret,
            access: this.access,
            generatedOn: this.generatedOn,
            cameras: this.cameras,
            vendor: this.vendor,
            user: this.user,
            client: this.client,
        };

        return data;
    }
}
